
import * as React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../Popover";
import { Input } from "../Input/Input";
import { ScrollArea, ScrollBar } from "../ScrollArea/ScrollArea";
import { Button } from "../Button";
import { DateTime } from "luxon";
import { TbCalendarTime, TbTimeline } from "react-icons/tb";


const regexNumber = new RegExp("^[0-9]+$");


interface TimePickerProps {
  value: Date | DateTime;
  onChange: (event: Date | DateTime) => void;
}


function TimePicker(props: TimePickerProps) {
  const { value, onChange, ...rest } = props;
  let currentValue = value instanceof Date ? DateTime.fromJSDate(value) : value instanceof DateTime ? value : DateTime.fromISO(value)
  const [toggle, setToggle] = React.useState(false)
  const [hour, setHour] = React.useState<number>(currentValue?.hour ? currentValue.hour : 0);
  const [minute, setMinute] = React.useState<number>(currentValue?.minute ? currentValue.minute : 0);

  const onChangeHour = React.useCallback((val: number) => {
    setHour(val)
    setToggle(false);
  }, []);

  const onChangeMinute = React.useCallback((val: number) => {
    setMinute(val)
    setToggle(false);
  }, []);

  React.useEffect(() => {
    if(value instanceof Date) {
      onChange(currentValue?.set({hour: hour, minute: minute}).toJSDate())
    } else {
      onChange(currentValue?.set({hour: hour, minute: minute}))
    }
  }, [hour, minute]);


  return (
    <div className="grid grid-cols-2 gap-2">
      <div className="flex gap-2">
        <Input
          type="number"
          inputMode="numeric"
          className="h-10 w-wull px-2"
          min={0}
          max={23}
          value={hour}
          onChange={({ target }) => {
            if (regexNumber.test(target.value)) {
              onChangeHour(parseFloat(target.value));
            }
          }}
        />
        {/* <Popover onOpenChange={setToggle}>
          <PopoverTrigger className="flex-none flex w-full" onClick={() => setToggle(!toggle)}>
            {hour}
          </PopoverTrigger>
          <PopoverContent className="w-20 p-1 h-32" align="end">
            <ScrollArea>
              <div className="flex flex-col h-full">
                {Array(24)
                  .fill("")
                  .map((item, idx) => (
                    <Button
                      key={idx}
                      variant="ghost"
                      size="sm"
                      className="w-20 justify-start"
                      onClick={() => {
                        onChangeHour(idx);
                      }}
                    >
                      {idx}
                    </Button>
                  ))}
              
              </div>
              <ScrollBar/>
              </ScrollArea>
            
          </PopoverContent>
        </Popover> */}
      </div>
      <div className="flex gap-2">
        <Input
          type="number"
          inputMode="numeric"
          className="h-10 w-full px-2"
          min={0}
          max={59}
          value={minute}
          onChange={({ target }) => {
            if (regexNumber.test(target.value)) {
              onChangeMinute(parseFloat(target.value));
            }
          }}
        />
        {/* <Popover onOpenChange={setToggle}>
          <PopoverTrigger className="flex-none flex w-6 justify-center items-center" onClick={() => setToggle(!toggle)}>
            <TbCalendarTime className="text-muted-foreground"/>
          </PopoverTrigger>
          <PopoverContent className="w-22 p-1" align="end">
            <ScrollArea>
              <div className="flex flex-col h-32">
                {Array(60)
                  .fill("")
                  .map((item, idx) => (
                    <Button
                      key={idx}
                      variant="ghost"
                      size="sm"
                      className="w-20 justify-start"
                      onClick={() => {
                        onChangeMinute(idx);
                      }}
                    >
                      {idx}
                    </Button>
                  ))}
              </div>
            </ScrollArea>
          </PopoverContent>
        </Popover> */}
      </div>
    </div>
  );
};

export default TimePicker